<template>
  <div class="user-welcome">
    <div class="user-info">
      <img
        v-if="user.avatar"
        :src="user.avatar"
        :alt="user.name"
        class="user-avatar"
      />
      <h1 class="welcome-text">Привет, {{ user.name }}</h1>
    </div>
    <button type="button" class="logout-button" @click="emit('logout')">
      <span class="logout-text">Выйти</span>
      <img :src="logoutIcon" alt="Выйти" class="logout-icon" />
    </button>
  </div>
</template>

<script setup>
/* global defineProps, defineEmits */
import logoutIcon from '@/widgets/booking/assets/img/icons/booking-logout.svg'

defineProps({
  user: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['logout'])
</script>

<style scoped lang="scss">
@import '@/widgets/booking/assets/scss/variables.scss';

.user-welcome {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: #F3F5F8;
  border-radius: 12px;
  margin-bottom: 16px;
  height: 68px;
  opacity: 1;
}

.user-info {
  display: flex;
  align-items: center;
  gap: $spacing-md;
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 21px;
  object-fit: cover;
}

.welcome-text {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  color: #333333;
  margin: 0;
}

.logout-button {
  display: flex;
  align-items: center;
  gap: $spacing-xs;
  padding: $spacing-xs $spacing-md;
  border: none;
  background: transparent;
  color: #9898A5;
  transition: opacity 0.2s ease;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
}

.logout-text {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  text-align: right;
}

.logout-icon {
  width: 20px;
  height: 20px;
  display: block;
}
</style>
